import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router';
import { useSession } from '@common/authorization/context/Session';
import SelfServiceLayout from './SelfServiceLayout';
import { useSelfServiceData } from '@selfservice/utils/useSelfServiceData';

export const SelfServiceContainer = () => {
  const { t } = useTranslation();
  document.title = t('self-service.browser-title');

  const { userInfo } = useSession();

  const { data } = useSelfServiceData();

  const logoUrl = data?.orgInfo?.logoUrl || '';
  const username = userInfo?.userDisplayName || userInfo?.userUpn || userInfo?.email || '';

  return (
    <SelfServiceLayout logoUrl={logoUrl} username={username} email={username}>
      <Outlet />
    </SelfServiceLayout>
  );
};
